module.exports = __webpack_public_path__ + "static/img/info-circle-gray.473d24d0.svg";